<template>
  <div class="login-page premium-code-login">
    <div class="login-topbar">
      <button
        class="icon-button"
        type="button"
        aria-label="返回密码登录"
        @click="login1"
      >
        <van-icon name="arrow-left" />
      </button>
      <div class="line-select">
        <span>安全验证</span>
        <strong>EMAIL</strong>
      </div>
    </div>

    <div class="hero">
      <div class="asm-login-logo">
        <span>ASM</span>
        <div>
          <strong>ASM太平洋</strong>
          <small>ASM PACIFIC WEALTH</small>
        </div>
      </div>
    </div>

    <main class="login-main">
      <h1>邮箱验证码登录</h1>
      <p class="company-name">安全登录您的财富管理账户</p>

      <div class="form-row">
        <label>邮箱</label>
        <input
          v-model.trim="emailName"
          type="text"
          autocomplete="username"
          placeholder="请输入"
        />
        <select v-model="emailSuffix" aria-label="邮箱后缀">
          <option
            v-for="suffix in emailSuffixes"
            :key="suffix"
            :value="suffix"
          >
            {{ suffix }}
          </option>
        </select>
      </div>

      <div class="form-row code-row">
        <label>验证码</label>
        <input
          v-model.trim="password"
          type="text"
          inputmode="numeric"
          autocomplete="one-time-code"
          placeholder="请输入验证码"
        />
        <button
          class="code-button"
          type="button"
          :disabled="disabled"
          @click="code"
        >
          {{ codeBtnTit }}
        </button>
      </div>

      <div class="link-row">
        <span @click="login1">账号密码登录</span>
        <span @click="$router.push({ name: 'RetrievePassword' })">忘记密码</span>
      </div>

      <van-button class="login-button" @click="submit">登录</van-button>
      <button class="register-link" type="button" @click="goTo">注册</button>
    </main>

    <div v-if="show" class="loading-mask">
      <div class="loading-box">{{ $t("m.dl_span12") }}</div>
    </div>
  </div>
</template>

<script>
import { loginMobile, loginMobile1 } from "@api/user";
import { required } from "@utils/validate";
import { validatorDefaultCatch } from "@utils/dialog";
import cookie from "@utils/store/cookie";

const BACK_URL = "login_back_url";
const DEFAULT_EMAIL_SUFFIXES = [
  "@gmail.com",
  "@outlook.com",
  "@hotmail.com",
  "@icloud.com",
  "@yahoo.com",
  "@proton.me",
  "@aol.com",
  "@live.com",
  "@msn.com",
  "@mail.com",
  "@qq.com",
  "@foxmail.com",
  "@163.com",
  "@126.com",
  "@sina.com",
  "@yeah.net",
  "@naver.com",
  "@daum.net",
  "@yandex.com"
];

export default {
  name: "Login1",
  data: function() {
    return {
      value: 86,
      disabled: false,
      alltime: 60,
      codeBtnTit: "获取验证码",
      show: false,
      emailName: "",
      emailSuffix: "@gmail.com",
      emailSuffixes: DEFAULT_EMAIL_SUFFIXES.slice(),
      password: ""
    };
  },
  mounted: function() {
    this.codeBtnTit = this.$t("m.dl_span9") || "获取验证码";
    const savedAccount = window.localStorage.getItem("zhanghao");
    if (savedAccount) {
      this.setEmailAccount(savedAccount);
    }
    if (window.localStorage.getItem("quhao")) {
      this.value = window.localStorage.getItem("quhao");
    }
  },
  methods: {
    login1() {
      this.$router.push({
        path: "/login"
      });
    },
    goTo() {
      this.$router.push({
        path: "/register"
      });
    },
    setEmailAccount(account) {
      const value = String(account || "").trim();
      const atIndex = value.indexOf("@");
      if (atIndex === -1) {
        this.emailName = value;
        return;
      }

      const suffix = value.slice(atIndex).toLowerCase();
      this.emailName = value.slice(0, atIndex);
      if (this.emailSuffixes.indexOf(suffix) === -1) {
        this.emailSuffixes.push(suffix);
      }
      this.emailSuffix = suffix;
    },
    getEmailAccount() {
      const account = String(this.emailName || "").trim();
      if (!account) {
        return "";
      }
      if (account.indexOf("@") > -1) {
        return account.toLowerCase();
      }
      return `${account}${this.emailSuffix}`.toLowerCase();
    },
    sendCode() {
      let alltime = this.alltime;
      if (alltime == 0) {
        this.alltime = 60;
        this.codeBtnTit = this.$t("m.dl_span9") || "获取验证码";
        this.disabled = false;
        return;
      }

      alltime--;
      this.codeBtnTit = (this.$t("m.dl_span13") || "重新发送") + alltime;
      this.alltime = alltime;
      this.disabled = true;
      setTimeout(() => {
        this.sendCode();
      }, 1000);
    },
    async code() {
      const emailAccount = this.getEmailAccount();
      try {
        await this.$validator({
          emailAccount: [required(required.message("邮箱"))]
        }).validate({ emailAccount });
      } catch (e) {
        return validatorDefaultCatch(e);
      }
      if (this.disabled) {
        return;
      }

      loginMobile1({
        email: emailAccount
      })
        .then(res => {
          this.$dialog.success(res.msg);
          this.sendCode();
        })
        .catch(res => {
          this.$dialog.error(res.response.data.msg);
        });
    },
    async submit() {
      const emailAccount = this.getEmailAccount();
      const { password } = this;
      try {
        await this.$validator({
          emailAccount: [required(required.message("邮箱"))],
          password: [required(required.message("验证码"))]
        }).validate({
          emailAccount,
          password
        });
      } catch (e) {
        return validatorDefaultCatch(e);
      }

      this.show = true;
      loginMobile({
        email: emailAccount,
        sms: password,
        system: "android"
      })
        .then(data => {
          this.show = false;
          let expires_time = new Date().getTime() + 86400 * 1000 - 28800000;
          const datas = {
            token: data.data.data.access_token,
            expires_time: expires_time,
            kf: data.data.data.kf,
            view: data.data.data.view
          };
          window.localStorage.setItem("zhanghao", emailAccount);
          window.localStorage.setItem("quhao", this.value);
          this.$store.commit("LOGIN", datas);
          cookie.remove(BACK_URL);
          this.$router.push({
            path: "/user"
          });
        })
        .catch(e => {
          this.show = false;
          this.$dialog.error(e.response.data.msg);
        });
    }
  }
};
</script>

<style scoped>
.login-page {
  min-height: 100vh;
  position: relative;
  overflow: hidden;
  background: #ffffff;
  color: #182033;
  padding: 22px 32px 56px;
  box-sizing: border-box;
}

.login-page::before {
  content: none;
  position: absolute;
  left: -138px;
  bottom: -118px;
  width: 340px;
  height: 340px;
  border-radius: 50%;
  background: repeating-radial-gradient(
    circle,
    rgba(3, 114, 251, 0.12) 0,
    rgba(3, 114, 251, 0.12) 1px,
    transparent 2px,
    transparent 9px
  );
}

.login-page::after {
  content: none;
  position: absolute;
  left: 0;
  right: 0;
  top: 330px;
  height: 170px;
  opacity: 0.16;
  background:
    linear-gradient(90deg, transparent 0 7%, rgba(201, 42, 42, 0.22) 7% 10%, transparent 10% 22%, rgba(3, 114, 251, 0.2) 22% 25%, transparent 25% 41%, rgba(201, 42, 42, 0.18) 41% 44%, transparent 44% 64%, rgba(3, 114, 251, 0.18) 64% 67%, transparent 67%),
    linear-gradient(0deg, transparent 49%, rgba(24, 32, 51, 0.24) 50%, transparent 51%);
}

.login-topbar,
.hero,
.login-main {
  position: relative;
  z-index: 1;
}

.login-topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.icon-button {
  width: 32px;
  height: 32px;
  border: 0;
  padding: 0;
  background: transparent;
  color: #172033;
  font-size: 24px;
}

.line-select {
  display: flex;
  align-items: baseline;
  gap: 6px;
  color: #172033;
  font-size: 15px;
}

.line-select strong {
  font-size: 20px;
  font-weight: 700;
}

.hero {
  min-height: 190px;
  padding-top: 44px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: flex-start;
}

.asm-login-logo {
  display: flex;
  align-items: center;
  gap: 15px;
}

.asm-login-logo > span {
  display: grid;
  width: 72px;
  height: 72px;
  place-items: center;
  color: #fff;
  font-size: 21px;
  font-weight: 800;
  background: linear-gradient(145deg, #092d68, #1772c4);
  border-radius: 22px;
  box-shadow: 0 14px 28px rgba(17, 81, 153, 0.2);
}

.asm-login-logo strong,
.asm-login-logo small {
  display: block;
}

.asm-login-logo strong {
  color: #0a3977;
  font-size: 27px;
  letter-spacing: 1px;
}

.asm-login-logo small {
  margin-top: 5px;
  color: #7890ab;
  font-size: 10px;
  letter-spacing: 1.4px;
}

.server-visual {
  position: relative;
  width: 188px;
  height: 152px;
  border-radius: 26px;
  background:
    linear-gradient(150deg, rgba(255, 255, 255, 0.92), rgba(3, 114, 251, 0.16)),
    linear-gradient(45deg, transparent, rgba(201, 42, 42, 0.18));
  box-shadow: 0 22px 48px rgba(3, 114, 251, 0.18);
}

.server-card {
  position: absolute;
  left: 38px;
  top: 34px;
  width: 102px;
  height: 78px;
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.78);
  border: 1px solid rgba(255, 255, 255, 0.82);
  display: flex;
  align-items: flex-end;
  justify-content: center;
  gap: 9px;
  padding-bottom: 16px;
}

.server-card::before {
  content: "";
  position: absolute;
  width: 68px;
  height: 68px;
  border: 6px solid rgba(201, 42, 42, 0.22);
  border-left-color: transparent;
  border-radius: 50%;
  right: -34px;
  top: -18px;
  transform: rotate(32deg);
}

.server-card span {
  width: 12px;
  border-radius: 8px 8px 4px 4px;
  background: linear-gradient(180deg, #0372fb, #c92a2a);
}

.server-card span:nth-child(1) {
  height: 28px;
}

.server-card span:nth-child(2) {
  height: 48px;
}

.server-card span:nth-child(3) {
  height: 36px;
}

.login-main h1 {
  margin: 0;
  font-size: 25px;
  line-height: 1.25;
  font-weight: 700;
  letter-spacing: 0;
}

.company-name {
  margin: 18px 0 42px;
  font-size: 18px;
  line-height: 1.45;
  color: #242c3d;
}

.form-row {
  height: 62px;
  display: flex;
  align-items: center;
  gap: 12px;
  border-bottom: 1px solid rgba(24, 32, 51, 0.22);
}

.form-row label {
  width: 56px;
  flex: 0 0 56px;
  color: #2d3445;
  font-size: 15px;
  font-weight: 600;
}

.form-row input {
  min-width: 0;
  flex: 1;
  height: 58px;
  border: 0;
  outline: none;
  background: transparent;
  color: #172033;
  font-size: 16px;
}

.form-row input::placeholder {
  color: rgba(24, 32, 51, 0.3);
}

.form-row select {
  flex: 0 0 auto;
  max-width: 132px;
  height: 42px;
  border: 0;
  outline: none;
  background: transparent;
  color: #2b3449;
  font-size: 15px;
  text-align: right;
}

.code-button {
  flex: 0 0 104px;
  min-width: 104px;
  height: 34px;
  border: 0;
  border-radius: 17px;
  background: rgba(3, 114, 251, 0.12);
  color: #0372fb;
  font-size: 13px;
  font-weight: 600;
}

.code-button:disabled {
  color: rgba(24, 32, 51, 0.42);
}

.link-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 30px;
  color: #c92a2a;
  font-size: 15px;
}

.link-row span {
  cursor: pointer;
}

.login-button {
  width: 100%;
  height: 54px;
  margin-top: 28px;
  border: 0;
  border-radius: 6px;
  background: linear-gradient(90deg, #0372fb, #155bd4);
  color: #ffffff;
  font-size: 20px;
  font-weight: 700;
}

.register-link {
  width: 100%;
  border: 0;
  background: transparent;
  color: #c92a2a;
  font-size: 17px;
  line-height: 52px;
  margin-top: 10px;
}

.loading-mask {
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 20;
}

.loading-box {
  background: rgba(0, 0, 0, 0.74);
  width: 130px;
  height: 130px;
  border-radius: 8px;
  text-align: center;
  line-height: 130px;
  color: #fff;
  font-size: 16px;
}

@media (max-width: 360px) {
  .login-page {
    padding-left: 24px;
    padding-right: 24px;
  }

  .company-name {
    font-size: 16px;
  }

  .form-row {
    gap: 8px;
  }

  .form-row select {
    max-width: 112px;
    font-size: 14px;
  }

  .code-button {
    flex-basis: 92px;
    min-width: 92px;
    font-size: 12px;
  }
}
</style>
